import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import { useContext, useState, useEffect } from 'react';
import { ApplicationMenuEvents } from '../../utils/applicationMenu/applicationMenu.js';
import { ApplicationMenuContext } from './ApplicationMenuContext.js';

function useSubscribeMenuItems(menu) {
  var contextMenu = useContext(ApplicationMenuContext);
  var subscribedMenu = menu || contextMenu;
  var _useState = useState(function () {
      return (subscribedMenu === null || subscribedMenu === void 0 ? void 0 : subscribedMenu.items) || [];
    }),
    _useState2 = _slicedToArray(_useState, 2),
    items = _useState2[0],
    setItems = _useState2[1];
  useEffect(function () {
    if (!subscribedMenu) {
      return undefined;
    }
    var handleMenuItemsChange = function handleMenuItemsChange() {
      setItems(subscribedMenu.items);
    };
    subscribedMenu.addEventListener(ApplicationMenuEvents.ItemsUpdated, handleMenuItemsChange);
    setItems(subscribedMenu.items);
    return function () {
      subscribedMenu.removeEventListener(ApplicationMenuEvents.ItemsUpdated, handleMenuItemsChange);
    };
  }, [subscribedMenu]);
  return items;
}

export { useSubscribeMenuItems };
